// extracted by mini-css-extract-plugin
export var accordionList = "accordion_list-module--accordionList--eqqnO";
export var list = "accordion_list-module--list--IweMX";